import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!["super_admin", "staff"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}

export function StudentRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/student-login" replace />;
  if (user.role !== "student") return <Navigate to="/dashboard" replace />;
  return children;
}
